module.exports = __webpack_public_path__ + "img/avatar.e50d3576.png";